export default {
    page: {
        px: [4, 4, 6, 6, 8],
        paddingTop: [4, 4, 6, 6, 8],
        paddingBottom: 32,
        width: '100%',
        maxWidth: 'container.4xl',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    fullPage: {
        px: 0,
        paddingTop: 0,
        paddingBottom: 0,
        width: '100%'
    }
}
